import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {DisplaySmall} from 'components/primitives/display';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {Header} from 'components/primitives/header';
import AcceptConsentLarge from 'services/consent/components/AcceptConsentLarge';
import {CONSENT_TYPES} from 'services/consent/consentTypes';
import {Button} from 'components/buttons/Button';
import FormField from 'components/inputs/FormField';
import {FormWarning} from 'components/inputs/FormWarning';
import {WithCompleteSignup} from 'api/users/WithCompleteSignup';
import {ALVA_TOKEN_KEY} from 'services/auth/constants';


export class AdditionalConsents extends React.Component {

    static propTypes = {
        token: PropTypes.string.isRequired,
        onCompleted: PropTypes.func.isRequired
    };

    state = {
        consents: {
            SHARE_DATA_OUTSIDE_EU: null,
            IMPROVE_ALVA: null,
            HANDLE_PERSONAL_DATA: null
        },
        triedToSubmit: false,
        notificationForceClosed: false
    };

    onConsentApprovalChanged = (agreement) => {
        this.setState(prevState => ({
            consents: Object.assign({}, prevState.consents, {[agreement.type]: agreement})
        }));
    };

    onSubmit = (doCompleteSignup, client) => {
        this.setState({triedToSubmit: true, notificationForceClosed: false});
        if (this.hasErrors()) {
            return;
        }
        doCompleteSignup({
            handlePersonalDataVersion: this.getConsentVersion(CONSENT_TYPES.HANDLE_PERSONAL_DATA),
            isImproveAlvaApproved: this.hasApprovedConsent(CONSENT_TYPES.IMPROVE_ALVA),
            improveAlvaVersion: this.getConsentVersion(CONSENT_TYPES.IMPROVE_ALVA),
            isShareDataOutsideEuApproved: this.hasApprovedConsent(CONSENT_TYPES.SHARE_DATA_OUTSIDE_EU),
            shareDataOutsideEuVersion: this.getConsentVersion(CONSENT_TYPES.SHARE_DATA_OUTSIDE_EU)
        }, this.props.token).then(({data: {completeSignup}}) => {
            if (completeSignup.ok) {
                localStorage.setItem(ALVA_TOKEN_KEY, completeSignup.authToken);
                client.cache.reset().then(() => {
                    this.props.onCompleted(completeSignup.authToken);
                });
            }
            else {
                throw new Error(completeSignup.errorMessage);
            }
        }).catch(e => {
            console.error(e);
        });
    };

    resetConsentType = (consentType) => {
        this.setState(prevState => ({
            consents: Object.assign({}, prevState.consents, {[consentType]: null})
        }));
    };

    shouldShowNotification = () => {
        return !this.state.notificationForceClosed && this.state.triedToSubmit && this.hasErrors();
    };

    hasErrors = () => {
        return !this.hasApprovedRequiredConsent() || !this.hasDecisionOnAllConsents();
    };

    hasApprovedRequiredConsent = () => {
        return this.hasApprovedConsent(CONSENT_TYPES.HANDLE_PERSONAL_DATA);
    };

    hasDecisionOnAllConsents = () => {
        return this.hasDecisionOnConsent(CONSENT_TYPES.HANDLE_PERSONAL_DATA)
            && this.hasDecisionOnConsent(CONSENT_TYPES.SHARE_DATA_OUTSIDE_EU)
            && this.hasDecisionOnConsent(CONSENT_TYPES.IMPROVE_ALVA);
    };

    hasDecisionOnConsent = (consentType) => {
        return !!this.state.consents[consentType];
    };

    hasApprovedConsent = (consentType) => {
        return !!this.state.consents[consentType] && this.state.consents[consentType].accepted;
    };

    getConsentVersion = (consentType) => {
        if (this.state.consents[consentType]) {
            return this.state.consents[consentType].revision;
        }
        return null;
    };

    forceCloseNotification = () => {
        this.setState({notificationForceClosed: true});
    };

    render() {
        return (
            <WithCompleteSignup>
                {({completeSignup, loading, client}) => (
                    <Wrapper>
                        <FormWarning visible={this.shouldShowNotification()} onClose={this.forceCloseNotification}>
                            <FormattedMessage {...messages.warning}/>
                        </FormWarning>
                        <Header>
                            <DisplaySmall>
                                <FormattedMessage {...messages.alvaWouldLikeTo}/>
                            </DisplaySmall>
                        </Header>
                        <FormField>
                            <AcceptConsentLarge
                                consentState={this.state.consents[CONSENT_TYPES.IMPROVE_ALVA]}
                                onChange={this.onConsentApprovalChanged}
                                onReset={this.resetConsentType}
                                type={CONSENT_TYPES.IMPROVE_ALVA}
                                linkToFull='/improve-alva'/>
                            <AcceptConsentLarge
                                consentState={this.state.consents[CONSENT_TYPES.SHARE_DATA_OUTSIDE_EU]}
                                onChange={this.onConsentApprovalChanged}
                                onReset={this.resetConsentType}
                                type={CONSENT_TYPES.SHARE_DATA_OUTSIDE_EU}
                                linkToFull='/share-data'/>
                            <AcceptConsentLarge
                                consentState={this.state.consents[CONSENT_TYPES.HANDLE_PERSONAL_DATA]}
                                onChange={this.onConsentApprovalChanged}
                                onReset={this.resetConsentType}
                                type={CONSENT_TYPES.HANDLE_PERSONAL_DATA}
                                linkToFull='/personal-data'/>
                        </FormField>
                        <FormField>
                            <Button
                                lookDisabled={this.hasErrors()}
                                onClick={this.onSubmit.bind(null, completeSignup, client)}
                                loading={loading}>
                                <FormattedMessage {...messages.continue} />
                            </Button>
                        </FormField>
                    </Wrapper>
                )}
            </WithCompleteSignup>
        );
    }
}


const Wrapper = styled.div`

`;


export default AdditionalConsents;
